import React, { useEffect, useState } from "react";
import RoundCheckIcon from "../../images/svg/RoundCheckIcon.svg";
import { ExternalLink } from "lucide-react";
import VehicleDetailModal from "../../Modal/VehicleDetailModal";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const VehicleDetails = ({ data, isLoading }) => {
  const [showVehicleDetailModal, setShowVehicleDetailModal] = useState(false);
  const [selectedEntry, setSelectedEntry] = useState(null);
  const [VehcileDetailsData, setVehicleDetailsData] = useState({});
  const [mParivahanData, setMParivanData] = useState([]);

  const handleButtonClick = (entry, index) => {
    setSelectedEntry({ id: entry, index: index });
    setShowVehicleDetailModal(true);
  };

  const mParivahanDataFun = (mparivanData) => {
    return [

      { label: "Owner Name", value: mparivanData?.owner_name || "N/A" },
      { label: "Ownership", value: mparivanData?.ownership || "N/A" },
      { label: "Registration Date", value: mparivanData?.vehicle_registration_date || "N/A" },
      { label: "Financer's Name", value: mparivanData?.financer_name || "N/A" },
      { label: "Registered RTO", value: mparivanData?.registered_rto || "N/A" },
      { label: "Color", value: mparivanData?.color || "N/A" },
      { label: "Unloaded Weight (Kg)", value: mparivanData?.unloaded_weight || "N/A" },
      { label: "RC Status", value: mparivanData?.rc_status || "N/A" },
      { label: "Maker Model", value: mparivanData?.vehicle_maker_model || "N/A" },
      { label: "Vehicle Class", value: mparivanData?.vehicle_class || "N/A" },
      { label: "Fuel Type", value: mparivanData?.vehicle_fuel_type || "N/A" },
      { label: "Fuel Norms", value: mparivanData?.vehicle_fuel_norms || "N/A" },
      { label: "Engine No.", value: mparivanData?.vehicle_engine_no || "N/A" },
      { label: "Insurance Expiry", value: mparivanData?.imp_date_insurance_expiry || "N/A" },

      { label: "Insurance Expiry", value: mparivanData?.imp_date_insurance_expiry || "N/A" },
      { label: "Vehicle Age", value: mparivanData?.imp_date_vehicle_age || "N/A" },
      { label: "Fitness Upto", value: mparivanData?.imp_date_fitness_upto || "N/A" },
      { label: "Registration Date", value: mparivanData?.vehicle_registration_date || "N/A" },

      { label: "Sleeper Capacity", value: mparivanData?.sleeper_capacity || "N/A" },
      { label: "Standing Capacity", value: mparivanData?.standing_capacity || "N/A" },
      { label: "Emission Norms", value: mparivanData?.vehicle_fuel_norms || "N/A" },
    ]

  }

  const setDetailsData = (id) => {
    const newData = data.filter((x) => x.vehicle_id === id)[0]
    const mparivanData = newData?.m_parivan_data;
    setMParivanData(mParivahanDataFun(mparivanData));
    setVehicleDetailsData(newData);
  };

  useEffect(() => {
    const newData = data ? data[0] : {};
    const mparivanData = newData?.m_parivan_data;
    setMParivanData(mParivahanDataFun(mparivanData));
    setVehicleDetailsData(newData);
  }, [data]);

  const loadingCount = Array.from({ length: 9 }, (_, index) => index);

  return (
    <div className="flex rounded-tl-[10px] rounded-tr-[10px] rounded-bl-[10px] rounded-br-[10px] h-screen-minus-216 w-auto">

      {/* First Column - Vehicle No. */}

      <div className="w-[15%] rounded-tl-[10px] rounded-bl-[10px] bg-white border-r h-full overflow-y-auto hideScrollBar relative">
        <div className="flex rounded-tl-[10px] items-center justify-center h-[60px] w-full border-b sticky top-0 bg-white z-10">
          <h4 className="text-black/opacity-60 text-[15px] font-normal font-['Roboto'] m-0 ">
            Vehicle No.
          </h4>
        </div>

        <div className="p-[10px] flex flex-col gap-1 h-full">
          {isLoading ? (
            <div className="animate-pulse space-y-4">
              {loadingCount?.map((item) => {
                return (
                  <div
                    key={item}
                    className="h-[51.20px] bg-[#FFF9E5] rounded w-full"
                  ></div>
                );
              })}
            </div>
          ) : data && data.length > 0 ? (
            data?.map((item, index) => {
              return (
                <div
                  key={index}
                  className={`w-full h-[51.20px] p-2.5 justify-center hover:cursor-pointer hover:border-[2px] border-[#ffe899] rounded-lg items-center gap-2.5 inline-flex ${item.vehicle_id == VehcileDetailsData?.vehicle_id
                    ? "bg-[#FFF9E5]"
                    : ""
                    }`}
                  onClick={() => setDetailsData(item.vehicle_id)}
                >
                  <div className="text-black text-sm font-medium font-['Roboto']">
                    {item.plate_number}
                  </div>
                </div>
              );
            })
          ) : (
            <div className="h-[80%] w-full flex items-center justify-center">
              <h2 className=" text-[15px] font-medium text-gray-400">
                No Data Available
              </h2>
            </div>
          )}
        </div>
      </div>

      <div className="flex bg-white flex-grow h-full w-[85%] rounded-tr-[10px] rounded-br-[10px]">
        <div className="flex m-3 border-2 border-yellow-400 rounded-lg w-full h-[95.5%] rounded-tr-[10px] rounded-br-[10px]">

          {/* Second Column - Vehicle RC Details */}

          <div className="flex-grow h-full w-[65%]">
            <div className="bg-white rounded-lg p-3.5 w-full h-full rounded-tr-[10px]">
              <h2 className="text-base text-gray-500 mb-2">
                {isLoading ? (
                  <Skeleton width={200} height={24} />
                ) : (
                  <>
                    <span className="text-black text-xl font-bold font-['Roboto']">
                      {VehcileDetailsData?.vehicle_no}
                    </span>
                    <span className="text-black/opacity-50 text-xl font-normal font-['Roboto']">
                      {" "}
                      Vehicle RC Details
                    </span>
                  </>
                )}
              </h2>
              <div className="border-t-2 border-b-2 border-gray-300 bg-white flex w-full flex-col gap-2 h-screen-minus-65 overflow-y-auto hideScrollBar">
                <div className="">
                  {isLoading ? (
                    Array(10).fill(0).map((_, index) => (
                      <div key={index} className="bg-[#FAFAFA] flex flex-col w-full gap-1 mb-2">
                        <Skeleton height={45} />
                      </div>
                    ))
                  ) : (
                    mParivahanData.map((each, index) => {
                      return (
                        <div
                          key={index}
                          className=" bg-[#FAFAFA] flex flex-col w-full gap-1"
                        >
                          <div className="flex items-center h-[45px]">
                            <div className="h-full w-1/2 flex items-center pl-2">
                              <h4 className="text-black text-sm font-normal font-['Roboto'] leading-[23px] m-0">
                                {each.label}:
                              </h4>{" "}
                            </div>
                            <div className="h-full w-1/2 bg-[#F5F5F5] flex items-center pl-2 border-b-[3px] border-[#FAFAFA]">
                              <h4 className="text-black text-sm font-medium font-['Roboto'] leading-[23px] m-0">
                                {each.value}
                              </h4>
                            </div>
                          </div>
                        </div>
                      );
                    })
                  )}
                </div>
              </div>
              <div className="text-green-700 font-medium mt-[0.5rem] w-[704px] text-[17px] font-['Roboto']">
                {VehcileDetailsData?.last_updated}
              </div>
            </div>
          </div>

          {/* Third Column - Entry-Exit History */}

          <div className="w-[35%] rounded-br-[10px]">
            <div className="bg-white rounded-lg p-3.5 w-full h-screen-minus-15 overflow-y-auto hideScrollBar rounded-br-[10px]">
              <div className="sticky top-0 bg-white z-10">
                {isLoading ? (
                  <Skeleton width={150} height={24} className="mb-2" />
                ) : (
                  <h3 className="text-black text-lg font-bold font-['Roboto'] m-0 pb-1">
                    Entry-Exit History
                  </h3>
                )}
              </div>
              <div className="h-screen-minus-15 overflow-y-auto hideScrollBar">
                <ul className="pl-0 mb-0 overflow-y-auto">
                  {isLoading ? (
                    Array(9).fill(0).map((_, index) => (
                      <li key={index} className="py-2.5">
                        <div className="flex items-center gap-2">
                          <Skeleton width={370} height={20} />
                        </div>
                      </li>
                    ))
                  ) : VehcileDetailsData?.vehicle_entry_exit?.length > 0 ? (
                    VehcileDetailsData.vehicle_entry_exit.map((entry, index) => (
                      <li
                        key={index}
                        className="flex items-center py-2.5 group text-black text-[15px] font-medium hover:bg-gray-50 hover:underline cursor-pointer relative"
                      >
                        <button
                          onClick={() =>
                            handleButtonClick(entry.user_vehicle_mapping_id, index)
                          }
                          className="flex items-center justify-between w-full text-left focus:outline-none"
                        >
                          <div className="flex items-center gap-1">
                            <img
                              src={RoundCheckIcon}
                              alt="Round Check Icon"
                              className="mr-2"
                            />
                            {entry.vehicle_history}
                          </div>
                          <div className="w-[77px]">
                            <ExternalLink
                              className="hidden group-hover:flex"
                              color="#0073c7"
                            />
                          </div>
                        </button>
                      </li>
                    ))
                  ) : (
                    <div className="flex items-center justify-center h-[calc(100vh-300px)]">
                      <h2 className="text-[15px] font-medium text-gray-400">
                        No Data Available
                      </h2>
                    </div>
                  )}
                </ul>
              </div>
            </div>

            {showVehicleDetailModal && (
              <VehicleDetailModal
                show={showVehicleDetailModal}
                onHide={() => setShowVehicleDetailModal(false)}
                entry={selectedEntry}
                EntryExistData={VehcileDetailsData?.vehicle_entry_exit}
              />
            )}
          </div>

        </div>
      </div>
    </div>
  );
};

export default VehicleDetails;